module.exports = __webpack_public_path__ + "static/media/medaille.67c1a855.png";